import colorsInjector from './colors-injector';

export default {
  colorsInjector,
};
